import { render, staticRenderFns } from "./RatingHistogram.vue?vue&type=template&id=d35f3a0e&scoped=true"
import script from "./RatingHistogram.vue?vue&type=script&lang=js"
export * from "./RatingHistogram.vue?vue&type=script&lang=js"
import style0 from "./RatingHistogram.vue?vue&type=style&index=0&id=d35f3a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f3a0e",
  null
  
)

export default component.exports